// Pure helper: walk up an Account's parent chain to find its "group"
// tag — the nearest non-brand, non-location ancestor. Used by the
// master grid's group filter + the role grids' group filter (P2b-3
// round-1 polish Fix 5).
//
// Returns:
//   - { id, name } when a group-typed ancestor exists (group / region
//     / head_office / dealership)
//   - null when the location is "Independent" (parent is the brand,
//     or the chain reaches the brand without crossing a group)
//
// This used to be private to MasterGrid.tsx; lifted to src/lib/ so the
// role grids reuse it without copy-paste drift.

import type { Account } from '../types/account.js';

export type GroupTagInfo = { id: string; name: string };

export function resolveGroupTag(
  accountId: string,
  accountsById: Map<string, Account>,
): GroupTagInfo | null {
  let cursor = accountsById.get(accountId)?.parentAccountId ?? null;
  while (cursor) {
    const acc = accountsById.get(cursor);
    if (!acc) return null;
    if (acc.accountType === 'brand') return null;
    if (acc.accountType !== 'location') return { id: acc.id, name: acc.name };
    cursor = acc.parentAccountId;
  }
  return null;
}
